import { ActivityIndicator, Linking, StyleSheet, Text, View } from "react-native";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, PAGES_ROUTES, PAGES_TITLE } from "utils/Constants";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { deleteUserSavedCard, getUserSavedCards } from "appRedux/reducers/profileSlice";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { router, useLocalSearchParams } from "expo-router";
import { showSuccess, showToast } from "src/utils/ToastUtils";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import ConfirmModal from "src/components/profile/confirmModal";
import ListView from "components/ListView";
import ParentScrollView from "components/ParentScrollView";
import PaymentCardsComp from "src/components/profile/paymentCardsComp";
import SideProfileComp from "components/profile/SideProfileComp";
import { Svg as svgs } from "assets/svg";
import VText from "components/VText";
import { trackV2 } from "utils/Segment";
import EmptyScreen
 from "components/emptyScreen";

const ManageSavedCards = ({}) => {
    const [isLoading, setLoader] = useState(false);
    const local = useLocalSearchParams();
    const localGender = local?.gender || "female";
    const [paymentCardsList, setPaymentCardsList] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const confirmModalRef = useRef(null);
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.AuthReducer.userId);

    useEffect(() => {
        fetchSavedCards();
    }, [dispatch]);

    useEffect(() => {
        if (paymentCardsList && paymentCardsList?.length > 0) {
            const eventData = {
                saved_cards_count: paymentCardsList?.length || 0,
            };
            trackV2(ANALYTICS_EVENT_NAMES.SAVED_CARDS_PAGE_VIEWED, eventData);
        }
    }, [paymentCardsList, paymentCardsList?.length]);

    const fetchSavedCards = () => {
        setLoader(true);
        dispatch(getUserSavedCards())
            .then((res) => {
                setLoader(false);
                if ([200].includes(res?.payload?.status)) {
                    setPaymentCardsList(res?.payload?.data?.bankDetailsList);
                } else {
                    setPaymentCardsList([]);
                }
            })
            .catch((err) => {
                setPaymentCardsList([]);
                setLoader(false);
                showToast("Error");
                console.log("err", err);
            });
    };

    const renderItem = ({ item }) => {
        return <PaymentCardsComp key={item?.customerProfileId} item={item} onPressCard={onPressCard} />;
    };

    const hideConfirmModal = () => {
        setDeleteId(null);
        confirmModalRef?.current?.hide();
    };

    const onPressCard = (productDetails) => {
        setDeleteId(productDetails?.customerPaymentProfileId);
        confirmModalRef?.current?.show(productDetails?.mask);
    };

    const onPressDelete = (mask) => {
        const payload = {
            userId: userId,
            paymentProfileIds: [deleteId],
        };
        hideConfirmModal();
        setLoader(true);
        dispatch(deleteUserSavedCard(payload))
            .then((res) => {
                const eventData = {
                    card_last_four: mask,
                };
                trackV2(ANALYTICS_EVENT_NAMES.SAVED_CARD_DELETED, eventData);
                showSuccess("Card Deleted Successfully");
                fetchSavedCards();
            })
            .catch((err) => {
                setLoader(false);
            });
    };

    const renderContent = useCallback(() => {
        if (isLoading) {
            return (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator size="large" color={Colors.black} />
                </View>
            );
        }
        if (paymentCardsList.length === 0) {
            return (

                    <EmptyScreen
                    
                    icon={svgs.manageCards}
                    title={'No credit card saved to your profile'}
                    description={'Please add your credit card details to securely save for future use.'}
                    buttonText={'Add New Card'}
                    onPress={() => {
                        router.push(`./add-card?gender=${localGender}`);
                    }}
                    />


               
            );
        }
        return (
            <View>
                <ListView
                    showsVerticalScrollIndicator={false}
                    data={Array.isArray(paymentCardsList) ? paymentCardsList : []}
                    contentContainerStyle={{ paddingBottom: 30 }}
                    renderItem={renderItem}
                    scrollEnabled={false}
                    keyExtractor={(item) => Math.random().toString()}
                />
                <Buttons
                    text={"Add New"}
                    noBorder={false}
                    containerStyle={[styles.addNewCardButton, { marginTop: spV(10) }]}
                    onPress={() => {
                        router.push(`./add-card?gender=${localGender}`);
                    }}
                />
            </View>
        );
    }, [paymentCardsList, isLoading]);

    return (
        <ParentScrollView>
            <View style={styles.container}>
                <VText style={styles.header}>Manage Saved Cards</VText>
                <View style={styles.content}>
                    <SideProfileComp gender={localGender} selected="Manage Saved Cards" />
                    <View style={styles.orderHistorySection}>{renderContent()}</View>
                </View>
            </View>
            <ConfirmModal ref={confirmModalRef} onPressDelete={onPressDelete} />
        </ParentScrollView>
    );
};
export default ManageSavedCards;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.white,
        paddingTop: spV(32),
    },

    addNewCardButton: {
        width: wp(200),
    },

    header: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
        marginBottom: spV(28),
    },
    content: {
        flex: 1,
        flexDirection: "row",
    },
    orderHistorySection: {
        width: wp(652),
        marginHorizontal: spH(80),
    },
    loadingContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    emptyText: {
        fontFamily: "JosefinSans",
        fontSize: 20,
        fontWeight: "550",
        textAlign: "center",
        marginTop: spV(15),
    },
    emptyContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
});
